import JsonApiRequest, { IDocument, IImage, IFile, IContact } from './JsonApiRequest';
import Cache from './Cache';

type TOwnerId = string;

let cache = {};

class OwnerInstance {
    protected ownerId = null;

    constructor(ownerId: TOwnerId) {
        this.ownerId = ownerId;
    }

    public getDocuments = (): Promise<Array<IDocument | IImage>> => {
        return JsonApiRequest.getRequest(`/media/document?include=field_document,thumbnail&filter[uid.id][value]=${this.ownerId}`)
            .then((res) => {
                const documentData = JsonApiRequest.data2Object<IDocument>(res.getData());

                return JsonApiRequest.getRequest(`/media/image?include=thumbnail&filter[uid.id][value]=${this.ownerId}`)
                    .then((res2) => {
                        const fileData = JsonApiRequest.data2Object<IImage>(res2.getData());

                        // TODO: filter for application files
                        return [...documentData, ...fileData];
                        // return documentData;
                    })
                    .catch((e) => {
                        console.error(e);
                        return Promise.reject(e);
                    });
            })
            .catch((e) => {
                return Promise.reject(e);
            });
    };

    public getContact = (): Promise<IContact> => {
        const cacheKey = 'contact' + this.ownerId;
        const cached = Cache.get(cacheKey);

        if (cached) {
            return Promise.resolve(cached);
        } else {
            const promise = JsonApiRequest.getRequest(`/real_estate_contact/real_estate_contact?filter[user_id.id][value]=${this.ownerId}`).then((res) => {
                const data = JsonApiRequest.data2Object<IContact>(res.getData()).find((e) => true);
                return data;
            });
            Cache.add(cacheKey, promise, 10000);
            return promise;
        }
    };
}

const Owner = (ownerId: TOwnerId) => {
    return new OwnerInstance(ownerId);
};

export default Owner;
